import { Button } from "@/components/ui/button"
import { Input } from "@/components/ui/input"
import { Label } from "@/components/ui/label"
import { AuthShell } from "@/components/layouts/auth-shell"
import { useForm, usePage, Link } from "@inertiajs/react"
import { FormEvent } from "react"
import { t } from "@/lib/i18n"
export default function StaffPasswordsEdit({ token }: { token: string }) {
    const { flash = {} } = usePage<{
        flash: {
            alert?: string
            notice?: string
        }
    }>().props
    const { data, setData, patch, processing } = useForm({
        password: "",
        password_confirmation: "",
    })
    const handleSubmit = (e: FormEvent) => {
        e.preventDefault()
        patch(`/passwords/${token}`)
    }
    return (<AuthShell title={t("ui.auth.titles.staff_password_edit")} headline={t("ui.auth.staff.headline")} blurb={t("ui.auth.staff.blurb")}>
      <div className="mb-8">
        <h1 className="text-2xl font-semibold tracking-tight">{t("ui.react.pages.staff.passwords.edit.choose_new_password")}</h1>
        <p className="mt-1 text-sm text-muted-foreground">{t("ui.react.pages.staff.passwords.edit.enter_new_password_twice")}</p>
      </div>

      <form onSubmit={handleSubmit} data-testid="password-reset-form">
        <div className="grid gap-6">
          {flash.alert && (<div className="rounded-md border border-destructive/40 bg-destructive/10 p-3 text-sm text-destructive">
              {flash.alert}
            </div>)}
          <div className="grid gap-2">
            <Label htmlFor="password">{t("ui.react.pages.staff.passwords.edit.new_password")}</Label>
            <Input id="password" type="password" value={data.password} onChange={(e) => setData("password", e.target.value)} required autoFocus autoComplete="new-password" maxLength={72}/>
          </div>
          <div className="grid gap-2">
            <Label htmlFor="password_confirmation">{t("ui.react.pages.staff.passwords.edit.confirm_new_password")}</Label>
            <Input id="password_confirmation" type="password" value={data.password_confirmation} onChange={(e) => setData("password_confirmation", e.target.value)} required autoComplete="new-password" maxLength={72}/>
          </div>
          <Button type="submit" className="w-full" disabled={processing} data-testid="save-new-password-button">{t("ui.react.pages.staff.passwords.edit.save_password")}</Button>
          <div className="text-center text-sm">
            <Link href="/session/new" className="underline underline-offset-4">{t("ui.react.pages.staff.passwords.edit.back_to_sign_in")}</Link>
          </div>
        </div>
      </form>
    </AuthShell>)
}
